import React, { useState, useEffect } from 'react'
import { Box, Select } from 'stylewhere/components'
import { CalendarPicker } from './CalendarPicker'
import { components } from 'react-select'

interface Option {
  label: string
  value: string
}

interface SelectDateProps {
  label?: string
  value?: string | { start: string; end: string }
  onChange: (val: string | { start: string; end: string } | undefined) => void
  options: Option[]
  placeholder?: string
}

const CUSTOM_VALUE = 'specific'

export const SelectDate: React.FC<SelectDateProps> = ({ value, onChange, options, placeholder, label }) => {
  const [selectedOption, setSelectedOption] = useState<Option | null>(null)
  const [range, setRange] = useState<{ start: Date | null; end: Date | null }>({ start: null, end: null })

  useEffect(() => {
    if (typeof value === 'string') {
      const match = options.find((o) => o.value === value)
      setSelectedOption(match || null)
      setRange({ start: null, end: null })
    } else if (value && typeof value === 'object' && value.start && value.end) {
      const dStart = new Date(value.start).toLocaleDateString('it-IT', {
        day: '2-digit',
        month: '2-digit',
        year: 'numeric'
      })
      const dEnd = new Date(value.end).toLocaleDateString('it-IT', {
        day: '2-digit',
        month: '2-digit',
        year: 'numeric'
      })
      const displayLabel = `${dStart} - ${dEnd}`
      setSelectedOption({ label: displayLabel, value: CUSTOM_VALUE })
      setRange({ start: new Date(value.start), end: new Date(value.end) })
    } else {
      setSelectedOption(null)
      setRange({ start: null, end: null })
    }
  }, [value, options])

  const handleSelect = (selected: Option | undefined) => {
    if (!selected) {
      onChange(undefined)
      return
    }
    onChange(selected.value)
  }

  const handleCalendarChange = (dates: [Date | null, Date | null]) => {
    const [start, end] = dates
    setRange({ start, end })

    if (start && end) {
      onChange({
        start: start.toISOString().slice(0, 10),
        end: end.toISOString().slice(0, 10)
      })
    }
  }

  const CustomMenuList: typeof components.MenuList = (props) => {
    return (
      <components.MenuList {...props}>
        {props.children}
        <Box mt={2} p={2} style={{ display: 'flex', justifyContent: 'center' }}>
          <CalendarPicker startDate={range.start} endDate={range.end} onChange={handleCalendarChange} />
        </Box>
      </components.MenuList>
    )
  }

  const filteredOptions = options.filter((opt) => opt.value !== CUSTOM_VALUE)

  return (
    <Select
      label={label}
      config={{ value: 'value', label: 'label' }}
      options={filteredOptions}
      value={selectedOption}
      onSelect={handleSelect}
      placeholder={placeholder || 'Seleziona data'}
      customComponents={{ MenuList: CustomMenuList }}
      isClearable={true}
    />
  )
}
